import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const HolidayService = {
  getHolidays() {
    return httpClient.post(endPoints.getHolidays);
  },
  deleteHoliday(obj) {
    return httpClient.post(endPoints.deleteHoliday, obj);
  },
  updateHoliday(obj) {
    return httpClient.post(endPoints.updateHoliday, obj);
  },
  addHoliday(obj) {
    return httpClient.post(endPoints.addHoliday, obj);
  },
  saveHoliday(obj) {
    return httpClient.post(endPoints.saveHoliday, obj);
  },
  syncfromGov(obj) {
    return httpClient.post(endPoints.syncfromGov, obj);
  }
};

export default HolidayService;



// WEBPACK FOOTER //
// ./src/service/HolidayService.js